import PropTypes from "prop-types";
import React from "react";
import Popup from "reactjs-popup";

// Mirrors the "Last edit was … ago at …" indicator on the confirm show page:
// a hover popup showing the changelog of versions.
const contentStyle = {
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "620px",
  height: "300px",
  overflow: "auto",
  padding: "25px 20px",
  zIndex: 9999, // above the sticky tab row (z-index 100)
};

const LastEditIndicator = ({ ago, time, versions }) => {
  if (!time) return null;

  return (
    <Popup
      arrow={false}
      offsetY={5}
      position="bottom right"
      contentStyle={contentStyle}
      className="changelog-popup"
      on="hover"
      trigger={() => (
        <a
          href="#"
          onClick={(e) => e.preventDefault()}
          className="page-actions-timestamp"
          style={{ textDecoration: "none", cursor: "default", color: "inherit" }}
        >
          Edited {ago} ago at {time}
        </a>
      )}
    >
      {() => (
        <div className="row">
          <div className="col-12">
            <strong style={{ fontSize: "16px" }}>Changelog</strong>
            <div className="table-responsive">
              <table className="table table-borderless small mt-3 mb-0">
                <tbody>
                  {(versions || []).map((version, index) => (
                    <tr key={index}>
                      <td className="pr-0 pb-0 pt-1 pl-0" style={{ width: "100px" }}>
                        <div>{version.date}</div>
                        <div className="text-muted">{version.time}</div>
                      </td>
                      <td className="pr-0 pb-0 pt-1">{version.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </Popup>
  );
};

LastEditIndicator.propTypes = {
  ago: PropTypes.string,
  time: PropTypes.string,
  versions: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
    message: PropTypes.string,
  })),
};

export default LastEditIndicator;
